var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'how__slide-picture': true,
    'how__slide-picture--video': true,
    'is-paused': _vm.isPaused,
    'is-active': _vm.isActive,
  },on:{"startVideo":_vm.startVideo,"pauseVideo":_vm.pauseVideo,"mouseenter":_vm.handleClick,"click":_vm.handleClick}},[_c('video',{ref:"video",attrs:{"loop":"","muted":""},domProps:{"muted":true}},[_c('source',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"data-src":_vm.videoUrl,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }